/* @flow */
import React, { useState, useRef } from "react";
import styled, { css } from "styled-components";
import Media from "react-media";
import { connect } from "react-redux";
import Gettext from "../common/Gettext";
import { mapStateToShowDeposit } from "../common/withDeposit";
import Popup from "../TradeMobile/Popup";
import ToggleAccount from "./ToggleAccount";
import AccountPicker from "./Account";
import { Fade } from "../common/Animations";

import { IronRedesignThemeProvider } from "../ThemeProvider";

import type { Account, Profile } from "../../redux/CommonTypes";
import Tour from "../Tour";

const Container = styled.div`
  display: inline-block;
  vertical-align: middle;
  margin-right: 20px;
  margin-left: 20px;
  font-size: 0px;
  line-height: 0;
  user-select: none;

  @media (max-width: 959px) {
    display: flex;
    flex: 1;
    overflow: hidden;
  }

  @media (max-width: 425px) {
    margin-left: 0;
    margin-right: 0;
  }

  ${({ isOriginal }) =>
    !isOriginal &&
    css`
      margin-left: 0;
      margin-right: 0;
      pointer-events: none;
    `};
`;

const Relative = styled.div`
  position: relative;

  @media (max-width: 959px) {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    flex: 1;
    overflow: hidden;
  }
`;

export type AccountType = "demo" | "real" | "tournament";

type Props = {
  accounts: Array<Account>,
  profile: Profile,
  activeAccount: Account,
  showDeposit: boolean,
  onDepositClick: () => void,
  onProfileUpdate: () => void,
  onRefillDemoClick: () => void,
  mode: "binary" | "tournament"
};

function AccountInHeader(props: Props) {
  const originalRef = useRef(null);
  const { profile, activeAccount, showDeposit } = props;
  const [isOpen, setIsOpen] = useState(false);

  const hide = e => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    setIsOpen(false);
  };

  const show = () => {
    setIsOpen(true);
  };

  const refill = () => {
    if (props.refillTournamentAvailable) {
      props.onRefillTournamentClick();
    } else if (props.refillDemoAvailable) {
      console.log("refill demo");
    }
  };

  if (typeof activeAccount !== "object") {
    return null;
  }

  return (
    <Tour
      step={["chartWithProfit", "dealsProfit"]}
      originalRef={originalRef}
      bgColor="green"
      withMobileArrow={true}
    >
      {({ next, isOriginal, step, isTourMode, balance, tour }) => (
        <Container
          ref={originalRef}
          onClick={
            isOriginal ? (showDeposit ? show : () => false) : () => false
          }
          type={!isTourMode ? activeAccount.type : "demo"}
          isOriginal={isOriginal}
        >
          <Relative>
            <IronRedesignThemeProvider>
              <AccountPicker
                tradeMode={!isTourMode ? props.mode : "binary"}
                type={!isTourMode ? activeAccount.type : "demo"}
                activeAccount={
                  !isTourMode
                    ? activeAccount
                    : {
                        balance: balance,
                        estimatedBalance: balance,
                        id: activeAccount.id,
                        isActive: true,
                        type: "demo"
                      }
                }
                profile={profile}
                showDeposit={showDeposit}
                isOpen={isOpen}
                mode={!isTourMode ? props.mode : "binary"}
                refillAvailable={
                  props.refillDemoAvailable ||
                  props.refillTournamentAvailable
                }
                onRefillClick={refill}
              />
            </IronRedesignThemeProvider>
          </Relative>
          <Media query="(min-width: 960px)">
            {matches =>
              matches ? (
                <Fade in={isOpen}>
                  {({ style }) => (
                    <ToggleAccount
                      profile={props.profile}
                      accounts={props.accounts}
                      refillDemoAvailable={props.refillDemoAvailable}
                      refillTournamentAvailable={
                        props.refillTournamentAvailable
                      }
                      showRefillLoader={props.showRefillLoader}
                      onRefillDemoClick={props.onRefillDemoClick}
                      onProfileUpdate={props.onProfileUpdate}
                      onClose={hide}
                      onDepositClick={props.onDepositClick}
                      style={style}
                      mode={props.mode}
                    />
                  )}
                </Fade>
              ) : (
                <Fade in={isOpen}>
                  {({ style }) => (
                    <Popup
                      title={<Gettext>Account type</Gettext>}
                      onClick={hide}
                      style={style}
                    >
                      <ToggleAccount
                        profile={props.profile}
                        accounts={props.accounts}
                        refillDemoAvailable={props.refillDemoAvailable}
                        refillTournamentAvailable={
                          props.refillTournamentAvailable
                        }
                        showRefillLoader={props.showRefillLoader}
                        onRefillDemoClick={props.onRefillDemoClick}
                        onProfileUpdate={props.onProfileUpdate}
                        onClose={hide}
                        onDepositClick={props.onDepositClick}
                        mode={props.mode}
                      />
                    </Popup>
                  )}
                </Fade>
              )
            }
          </Media>
        </Container>
      )}
    </Tour>
  );
}

function mapStateToProps(state) {
  return {
    ...mapStateToShowDeposit(state),
    mode: state.settings.mode
  };
}

export default connect(mapStateToProps)(AccountInHeader);



// WEBPACK FOOTER //
// ./src/components/AccountType/AccountInHeader.js